import { Navigate, useLocation, useSearchParams } from 'react-router';
import { legacyQueueRedirect } from './queue-params';
import { TicketListPage } from './TicketListPage';

/**
 * Coda dei ticket (PAGE-001): la home della console, con il lavoro da fare (Nuovo, In lavorazione, In
 * attesa dell'utente). Un vecchio link con una vista tolta con l'archivio (#123) porta dove vive oggi
 * quella lista: `?view=aperti` alla coda, `?view=risolti` all'archivio filtrato, senza lasciare la voce
 * vecchia nella cronologia.
 */
export function CodaPage() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const redirect = legacyQueueRedirect(pathname, searchParams);
  if (redirect) return <Navigate to={redirect} replace />;
  return <TicketListPage scope="coda" />;
}

/** Archivio (#123, PAGE-001): i ticket Risolto, Chiuso e Scartato, con la tabella e i filtri della coda. */
export function ArchivioPage() {
  return <TicketListPage scope="archivio" />;
}
